module.exports = __webpack_public_path__ + "static/img/bio.511f73e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bio.jpg
// module id = SeTF
// module chunks = 0